import { ConfirmationOrder } from '@models/confirmation-order';
import {
  AnalyticsTrackingService,
  TrackingIssuerType,
  TrackingOrderType,
  TrackingOrigin,
} from 'src/core/services/analyticsTracking.service';

export const GENERAL_CODE_CALLBACKS = {
  SUCCESS: 'Success',
};

export class TradeInfo {
  private type: string;
  private confirmationOrder: ConfirmationOrder;
  private success: boolean;
  private callback: string;
  private mutualFunds: boolean;
  private issuerType: string;
  private origin: TrackingOrigin;
  private instrumentType: string;
  private quantity: string;
  private transactionType: string;
  private amount?: string;
  private price?: string;
  private orderType?: string;
  private fundType?: string;
  private duration?: string;
  private isMaxSelected?: boolean;

  constructor(
    isTradingUSA: boolean,
    confirmationOrder: ConfirmationOrder,
    orderType: TrackingOrderType | TrackingIssuerType,
    origin: string,
    titles: string,
    saleType: string,
    amount?: string,
    price?: string,
    duration?: string,
    fundType?: string,
    isMaxSelected?: boolean,
  ) {
    this.type = isTradingUSA ? 'Trading Global' : 'Trading';
    /**
     * fundType only if we traded a fund,
     * fund mutualFunds = true,
     * actions mutualFunds = false
     */

    this.mutualFunds = !!fundType;

    this.issuerType = !fundType ? TrackingIssuerType.Capital : orderType;

    this.orderType = !fundType ? orderType : undefined;
    this.confirmationOrder = confirmationOrder;
    this.origin = new AnalyticsTrackingService().processOrigin(origin);
    this.instrumentType = !isTradingUSA
      ? INSTRUMENT_TYPE_KEY[confirmationOrder.instrumentType]
      : INSTRUMENT_TYPE_KEY[1];
    this.quantity = titles;
    this.transactionType =
      new AnalyticsTrackingService().processTransactionType(saleType);
    this.amount = amount || undefined;
    this.price = price || undefined;
    this.fundType = fundType || undefined;
    this.duration = duration ?? undefined;
    this.isMaxSelected = isMaxSelected ?? false;
  }

  public setSuccess(success: boolean) {
    this.success = success;
  }

  public setCallback(callback: string) {
    this.callback = callback;
  }

  public getAnaliticsTradeInfo() {
    return {
      Amount: this.amount,
      Callback: this.callback,
      'Fund type': this.fundType,
      'Instrument type': this.instrumentType,
      Issuer: this.confirmationOrder.issueID || this.confirmationOrder.issueId,
      'Issuer type': this.issuerType,
      'Mutual Funds': this.mutualFunds,
      'Order type': this.orderType,
      Origin: this.origin,
      Quantity: this.quantity,
      Price: this.price,
      Success: this.success,
      'Transaction type': this.transactionType,
      Type: this.type,
      Duration: this.duration,
      'Max selected': this.isMaxSelected,
    };
  }
}

const INSTRUMENT_TYPE_KEY: { [key: number]: string } = {
  0: 'NAC',
  1: 'USA',
  2: 'SIC',
  27: 'Debt',
  28: 'Equity',
};
